export default "__VITE_ASSET__GJLSavf5__"